'use strict';

/*@ngInject*/
module.exports = function accessibilityService($http) {

    this.getByPageName = function (page) {
        return $http.get('accessibility/getByPageName/' + page);
    };

    this.getArticles = function () {
        return $http.get('accessibility/getArticles/');
    };

    this.getArticleDataById = function (articleId) {
        return $http.get('accessibility/getArticleDataById/' + articleId);
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/accessibility.service.js
 **/